<template>
  <header class="navbar py-4">
    <div class="container d-flex flex-row align-items-center justify-content-between">
      <router-link :to="{ name: 'home' }" tag="a" class="logo">
        <img src="/site-logo.svg" alt="Juodeliai" class="h-100" />
      </router-link>

      <nav class="d-xl-flex flex-row d-none">
        <ul class="d-flex nav-list align-items-center">
          <li>
            <button
              class="nav-link"
              type="button"
              :class="{ 'active-btn': activeSidebar === 'contacts' }"
              @click.stop="$emit('showContacts')"
            >
              {{ $t('common.contactsLabel') }}
            </button>

            <div v-if="userLoadStatus === 1" class="user-icon user-icon--skeleton" />
          </li>

          <li>
            <router-link
              v-if="!user"
              :to="{ name: 'login' }"
              tag="button"
              class="btn btn-primary d-flex align-items-center justify-content-center"
            >
              <i class="fas fa-sign-in-alt mr-2"></i>
              <span>{{ $t('common.loginLabel') }}</span>
            </router-link>
          </li>
        </ul>

        <div v-if="!!user" class="position-relative">
          <button class="nav-link" type="button" @click.stop="makeActiveMenu('user')">
            <i class="far fa-user-circle"></i>
          </button>

          <div v-if="showUserMenu" v-on-clickaway="close" class="user-menu">
            <button
              v-if="isAdmin"
              type="button"
              class="btn btn-dropdown d-flex align-items-center justify-content-between"
              @click="redirectToBO"
            >
              <span class="d-flex align-items-center justify-content-between">
                <i class="icon fas fa-user-lock"></i>

                Backoffice
              </span>
            </button>

            <router-link
              :to="{ name: 'profile' }"
              tag="button"
              class="btn btn-dropdown d-flex align-items-center justify-content-between"
            >
              <span class="d-flex align-items-center justify-content-between">
                <i class="icon fas fa-user"></i>
                {{ $t('common.profileLabel') }}
              </span>
            </router-link>

            <router-link
              :to="{ name: 'reservations' }"
              tag="button"
              class="btn btn-dropdown d-flex align-items-center justify-content-between"
            >
              <span class="d-flex align-items-center justify-content-between">
                <i class="icon fas fa-list-ol"></i>
                {{ $t('common.reservationHistoryLabel') }}
              </span>
            </router-link>

            <button
              type="button"
              class="btn btn-dropdown d-flex align-items-center justify-content-between"
              @click="logout"
            >
              <span class="d-flex align-items-center justify-content-between">
                <i class="icon fas fa-sign-out-alt"></i>

                {{ $t('common.logoutLabel') }}
              </span>
            </button>
          </div>
        </div>
      </nav>

      <div class="d-xl-none ml-auto flex-row d-flex">
        <button type="button" class="nav-link" @click.stop="showMobileMenu = !showMobileMenu">
          <i class="fas fa-bars"></i>
        </button>
      </div>

      <div
        v-on-clickaway="hideMobileMenu"
        class="drawer-nav drawer-nav--left"
        :class="{ 'is-open': showMobileMenu }"
      >
        <div class="drawer-nav__wrapper">
          <div class="w-100">
            <div>
              <button type="button" class="sidebar-button" @click.stop="$emit('showContacts')">
                {{ $t('common.contactsLabel') }}
              </button>

              <div v-if="!!user">
                <button v-if="isAdmin" type="button" class="sidebar-button" @click="redirectToBO">
                  <span class="d-flex align-items-center justify-content-between">
                    <i class="fas fa-user-lock icon"></i>
                    Backoffice
                  </span>
                </button>

                <router-link :to="{ name: 'profile' }" class="sidebar-link">
                  <span class="d-flex align-items-center justify-content-between">
                    <i class="fas fa-user icon"></i>
                    {{ $t('common.profileLabel') }}
                  </span>
                </router-link>

                <router-link :to="{ name: 'reservations' }" class="sidebar-link">
                  <span class="d-flex align-items-center justify-content-between">
                    <i class="fas fa-list-ol icon"></i>
                    {{ $t('common.reservationHistoryLabel') }}
                  </span>
                </router-link>

                <button type="button" class="sidebar-button" @click="logout">
                  <span class="d-flex align-items-center justify-content-between">
                    <i class="icon fas fa-sign-out-alt"></i>
                    {{ $t('common.logoutLabel') }}
                  </span>
                </button>
              </div>

              <router-link v-else :to="{ name: 'login' }" class="sidebar-link">
                <span class="d-flex align-items-center justify-content-between">
                  <i class="fas fa-sign-in-alt icon"></i>
                  {{ $t('common.loginLabel') }}
                </span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex';
import { getCurrentLanguage } from '../../../utils';

export default {
  name: 'Navbar',
  props: {
    activeSidebar: {
      type: String,
      required: false,
      default: null,
    },
    closeNavbarMenus: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      showUserMenu: false,
      showMobileMenu: false,
    };
  },
  computed: {
    ...mapGetters({
      user: 'user',
      isAdmin: 'isAdmin',
      userLoadStatus: 'userLoadStatus',
    }),
  },
  watch: {
    closeNavbarMenus(val) {
      if (val) {
        this.showUserMenu = false;
        this.showMobileMenu = false;
      }
    },
    showUserMenu(val) {
      this.$emit('toggleNavbarMenu', !val);
    },
    showMobileMenu(val) {
      this.$emit('toggleNavbarMenu', !val);
    },
  },
  methods: {
    logout() {
      axios.post('/logout').then(() => {
        this.$store.dispatch('setUser', null);
        this.$store.dispatch('setIsAdmin', false);
        localStorage.removeItem('wua');
        window.location.href = `/${getCurrentLanguage()}`;
      });
    },
    redirectToBO() {
      window.location.href = `/${getCurrentLanguage()}/admin`;
    },
    makeActiveMenu(type) {
      if (type === 'user') {
        this.showUserMenu = !this.showUserMenu;
      }
    },
    close() {
      this.showUserMenu = false;
    },
    hideMobileMenu() {
      this.showMobileMenu = false;
    },
  },
};
</script>
